import React from 'react';
const PHONE_NUMBER = '+32 472 217 200';
const MAIL = 'orthodontie.overijse@gmail.com';
export const PhoneNumber = () => (
    <a href={`tel:${PHONE_NUMBER.replace(' ', '')}`}>{PHONE_NUMBER}</a>
);
export const EmailAddress = () => <a href={`mailto:${MAIL}`}>{MAIL}</a>;
